/**
 * Frontend mirror of the BACKEND money model's vocabulary — `be/config/pricingEconomics.js`.
 *
 * ⚠️ CODES ONLY, no rates and no Arabic. The rates are TRANSMITTED with each payload
 * (`economics.rates`, `worksheet.commissionRate`) precisely so the browser never carries a
 * second copy of the money model — that is the drift `pricingEconomics.js` exists to
 * prevent, and re-declaring 25% here would reopen it.
 *
 * What DOES belong here is the enum vocabulary the browser has to branch on. Same pattern
 * and same reasoning as `arrivalLabels.js` / `relocationLabels.js` / `ownerBillingLabels.js`:
 * a value the backend and the frontend must agree on lives in one named place, not as a
 * bare string literal inside whichever component needed it first.
 *
 * ⚠️ MUST MATCH BACKEND. Every value here is a value in `be/config/pricingEconomics.js`.
 *
 * Unlike the label files this one is NOT Arabic and NOT presentation — it is shared by the
 * billing worksheet and the pricing guidance panel, which is exactly why it cannot live in
 * either one's label file.
 */

/**
 * What Host Me's management fee is charged ON.
 *
 * ⚠️ NOT a VAT footing. "What footing did the platform give us?" is a data question
 * answered per platform; this is the COMMERCIAL question — what our contract says we
 * charge on — and it is the same on every platform. Conflating the two is what produced
 * the 2026-08-20 change (`tasks/billing-vat-inclusive-basis.md`).
 *
 * Mirrors `REVENUE_BASIS` in `be/config/pricingEconomics.js`. The basis in force is never
 * assumed here — it arrives on the payload (`economics.rates.revenueBasis`,
 * `worksheet.calculationBasis.revenueBasis`) so the server stays the single authority.
 */
export const REVENUE_BASIS = {
  VAT_INCLUSIVE: 'vat_inclusive_room_revenue',
  VAT_EXCLUSIVE: 'vat_exclusive_room_revenue'
};

/** Does a payload's declared basis mean the fee bills on revenue + VAT? */
export const billsOnVatInclusive = (revenueBasis) => revenueBasis === REVENUE_BASIS.VAT_INCLUSIVE;
